import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const BreadcrumbStyle = ({ theme }) => ({
  margin: '15px auto 32px auto',
  [theme.breakpoints.up('md')]: {
    marginBottom: '24px',
    marginTop: '10px'
  }
});

export const BannerWrapperStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: '12px',
  boxShadow: theme.shadows[3],
  margin: '30px 0px'
});

export const BreadcrumbWrapStyled = styled(Box)(BreadcrumbStyle);

export const BannerWrapperStyled = styled(Box)(BannerWrapperStyle);
